module.exports = __webpack_public_path__ + "static/media/twitter.34f596da.svg";